/* CONIUNCTA Entwicklungsmuster-Hinweis: Block nur bei gewaehlter Muster-Variante (SKU-Suffix -EM) zeigen
   und die Bestellmenge fuer Muster auf 1 festhalten (Adrian, 05.09.2026: "Menge 1").
   Gehoert zu snippets/coni-entwicklungsmuster.liquid. Folgt dem Variantenwechsel des Themes (FoxTheme.pubsub).
   Mengenwaehler: <quantity-input data-section-id> im Kaufblock und in der Sticky-Leiste (gleiche section id).
   Ein Muster je Kunde und Artikel (Adrian, 09.09.2026): data-already="1" (Liquid, Metafeld coniuncta.em_kunden) sperrt den
   Kaufbutton bei gewaehlter Muster-Variante (Text "Muster bereits bestellt"), faengt den Submit ab und wechselt beim Laden
   auf das Gebinde. Die Sperre ist Komfort im Theme; die Pruefung im Worker (Bestellung) bleibt die verbindliche Stelle. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.coniEmReady) return;
    root.dataset.coniEmReady = '1';
    var suffix = root.dataset.suffix || '-EM';
    var sid = root.dataset.sectionId || '';
    var isSampleNow = !root.hidden;
    var already = root.dataset.already === '1';
    var alreadyLabel = root.dataset.alreadyLabel || '';
    var sampleIds = (root.dataset.sampleIds || '').split(',').filter(Boolean);
    var back = null;
    Array.prototype.forEach.call(document.querySelectorAll('.coni-em-back'), function (el) {
      if (!back && (el.dataset.sectionId || '') === sid) back = el;
    });
    function scopeEl() { return root.closest('product-info') || document; }
    // Umschalter: Picker (Select oder Radio) auf den Optionswert setzen, das Theme uebernimmt den Variantenwechsel.
    function selectValue(val) {
      if (!val) return false;
      var scope = scopeEl();
      var selects = scope.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var s = selects[i];
        for (var j = 0; j < s.options.length; j++) {
          if (s.options[j].value === val) {
            if (s.value !== val) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
            return true;
          }
        }
      }
      var radios = scope.querySelectorAll('input[type="radio"]');
      for (i = 0; i < radios.length; i++) {
        if (radios[i].value === val) {
          if (!radios[i].checked) { radios[i].checked = true; radios[i].dispatchEvent(new Event('change', { bubbles: true })); }
          return true;
        }
      }
      return false;
    }
    // Bio gewaehlt, aber Traeger nicht bio-faehig: Traeger auf den ersten bio-faehigen Wert stellen, das Theme waehlt dann die Bio-Variante.
    var bioValue = root.dataset.bioValue || '';
    var bioCarriers = (root.dataset.bioCarriers || '').split('|').filter(Boolean);
    document.addEventListener('change', function (ev) {
      var sel = ev.target;
      if (!bioValue || !bioCarriers.length || !sel || sel.tagName !== 'SELECT' || sel.value !== bioValue) return;
      if (!scopeEl().contains(sel)) return;
      var selects = scopeEl().querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var s = selects[i];
        if (s === sel) continue;
        var hasCarrier = false;
        for (var j = 0; j < s.options.length; j++) { if (bioCarriers.indexOf(s.options[j].value) !== -1) { hasCarrier = true; break; } }
        if (!hasCarrier) continue;
        if (bioCarriers.indexOf(s.value) === -1) {
          // Das Theme setzt die Qualitaet bei unverfuegbarer Kombination sofort zurueck: erst Traeger umstellen, dann Bio erneut waehlen.
          window.setTimeout(function () {
            selectValue(bioCarriers[0]);
            window.setTimeout(function () { selectValue(bioValue); }, 250);
          }, 50);
        }
        break;
      }
    }, true);
    document.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-coni-em-switch]') : null;
      if (!btn) return;
      var holder = btn.closest('.coni-em, .coni-em-back');
      if (holder && (holder.dataset.sectionId || '') !== sid) return;
      ev.preventDefault();
      selectValue(btn.dataset.coniEmSwitch === 'sample' ? root.dataset.sampleValue : root.dataset.bulkValue);
    });
    function isSample(sku) {
      sku = String(sku || '');
      return sku.length > suffix.length && sku.slice(-suffix.length) === suffix;
    }
    // Kaufbuttons aller Formulare der Seite (Kaufblock, Sticky-Leiste, Quick-View), die auf eine Muster-Variante zeigen:
    // massgeblich ist die Varianten-ID im Feld name="id" des zugehoerigen Formulars (button.form beruecksichtigt das form-Attribut).
    // Achtung: form.id ist hier das Eingabefeld name="id", deshalb nie form.id fuer die Formular-ID benutzen.
    function sampleForms() {
      var out = [];
      Array.prototype.forEach.call(document.querySelectorAll('button[name="add"]'), function (b) {
        var f = b.form;
        if (!f) return;
        var idIn = f.querySelector('input[name="id"], select[name="id"]');
        out.push({ btn: b, sample: !!idIn && sampleIds.indexOf(String(idIn.value)) !== -1 });
      });
      return out;
    }
    // Sperre "Muster bereits bestellt": Button deaktivieren und beschriften, solange das Formular eine Muster-Variante traegt.
    function applyBuy() {
      sampleForms().forEach(function (x) {
        var btn = x.btn;
        var lock = already && x.sample;
        var span = btn.querySelector('.btn__text') || btn.querySelector('span');
        if (lock) {
          if (!btn.dataset.coniEmBlocked) {
            btn.dataset.coniEmBlocked = '1';
            btn.dataset.coniEmText = span ? span.textContent : btn.textContent;
          }
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-disabled', 'true');
          if (alreadyLabel) {
            if (span) { if (span.textContent !== alreadyLabel) span.textContent = alreadyLabel; }
            else if (btn.textContent !== alreadyLabel) btn.textContent = alreadyLabel;
          }
        } else if (btn.dataset.coniEmBlocked) {
          delete btn.dataset.coniEmBlocked;
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
          var t = btn.dataset.coniEmText;
          delete btn.dataset.coniEmText;
          if (t) { if (span) span.textContent = t; else btn.textContent = t; }
        }
      });
    }
    // Sicherheitsnetz: Submit eines Kaufformulars mit Muster-Variante abfangen, wenn das Muster bereits bestellt wurde.
    if (already) {
      document.addEventListener('submit', function (ev) {
        var f = ev.target;
        if (!f || f.tagName !== 'FORM') return;
        var idInput = f.querySelector('input[name="id"], select[name="id"]');
        if (!idInput || sampleIds.indexOf(String(idInput.value)) === -1) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        applyBuy();
      }, true);
    }
    function qtyBoxes() {
      var sel = sid ? 'quantity-input[data-section-id="' + sid + '"]' : 'quantity-input';
      return Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (q) { return !q.classList.contains('cart-quantity'); });
    }
    // Theme-Prognose "Voraussichtliche Lieferzeit" (Block shipping) gilt fuer Gebinde, nicht fuer Muster: ausblenden.
    function applyShipping() {
      var scope = root.closest('product-info') || document;
      Array.prototype.forEach.call(scope.querySelectorAll('.product__block--shipping'), function (el) {
        if (isSampleNow) { el.dataset.coniEmHidden = '1'; el.hidden = true; }
        else if (el.dataset.coniEmHidden) { delete el.dataset.coniEmHidden; el.hidden = false; }
      });
    }
    // Menge 1: Eingabe auf 1 setzen und sperren, Plus/Minus ausblenden; bei Basisvarianten wieder freigeben.
    function applyQty() {
      qtyBoxes().forEach(function (q) {
        var inp = q.querySelector('input[name="quantity"]');
        if (!inp) return;
        if (isSampleNow) {
          if (inp.value !== '1') { inp.value = '1'; inp.dispatchEvent(new Event('change', { bubbles: true })); }
          inp.setAttribute('max', '1');
          inp.setAttribute('readonly', 'readonly');
          inp.dataset.coniEmLocked = '1';
          q.classList.add('coni-em-qty-locked');
        } else if (inp.dataset.coniEmLocked) {
          inp.removeAttribute('max');
          inp.removeAttribute('readonly');
          delete inp.dataset.coniEmLocked;
          q.classList.remove('coni-em-qty-locked');
        }
      });
    }
    try {
      if (window.FoxTheme && FoxTheme.pubsub && typeof FoxTheme.pubsub.subscribe === 'function') {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (e) {
          var d = e && e.data ? e.data : e;
          if (!d || !d.variant) return;
          if (d.sectionId && sid && d.sectionId !== sid) return;
          isSampleNow = isSample(d.variant.sku);
          root.hidden = !isSampleNow;
          if (back) back.hidden = isSampleNow;
          applyQty();
          applyShipping();
          applyBuy();
          // Das Theme setzt den Button nach dem Rendern erneut (toggleAddButton): Sperre verzoegert wiederholen.
          window.setTimeout(applyBuy, 250);
          window.setTimeout(applyBuy, 800);
        });
      }
    } catch (e) { /* ohne pubsub bleibt der Stand beim Laden */ }
    // Das Theme rendert den Kaufblock beim Variantenwechsel neu: Sperre nach DOM-Aenderungen erneut anwenden.
    var scope = root.closest('product-info') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { if (isSampleNow) { applyQty(); applyShipping(); } }).observe(scope, { childList: true, subtree: true });
      if (already) {
        var buyTimer = null;
        new MutationObserver(function () {
          if (buyTimer) return;
          buyTimer = window.setTimeout(function () { buyTimer = null; applyBuy(); }, 40);
        }).observe(document.body, { childList: true, subtree: true });
      }
    }
    // Tastatur/Scroll im Eingabefeld bei gesperrter Menge abfangen (readonly stoppt kein Mausrad in allen Browsern).
    document.addEventListener('input', function (ev) {
      var t = ev.target;
      if (t && t.dataset && t.dataset.coniEmLocked && t.value !== '1') { t.value = '1'; }
    }, true);
    applyQty();
    applyShipping();
    applyBuy();
    // Muster bereits bestellt und Muster vorausgewaehlt: beim Laden auf das Gebinde wechseln (der Block zeigt dann die Zeile "bereits bestellt").
    if (already && isSampleNow && root.dataset.bulkValue) {
      window.setTimeout(function () { if (isSampleNow) selectValue(root.dataset.bulkValue); }, 300);
    }
  }
  // "?"-Blaeschen im Block (Beispiel-CoA, ein Muster je Kunde und Artikel): eigene Klassen, delegierte Listener, einmal je Seite.
  var HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  function hilfePlace(h) {
    var pop = h.querySelector('.coni-em-hilfe__pop');
    if (!pop || pop.hidden) return;
    pop.style.left = '0px';
    var vw = document.documentElement.clientWidth;
    var br = h.getBoundingClientRect();
    var pr = pop.getBoundingClientRect();
    var left = 0;
    if (br.left + pr.width > vw - 12) left = (vw - 12) - (br.left + pr.width);
    if (br.left + left < 12) left = 12 - br.left;
    pop.style.left = left + 'px';
    pop.style.setProperty('--coni-hilfe-caret', (4 - left) + 'px');
  }
  function hilfeSet(h, on) {
    var btn = h.querySelector('.coni-em-hilfe__btn');
    var pop = h.querySelector('.coni-em-hilfe__pop');
    if (!btn || !pop) return;
    h.classList.toggle('is-open', on);
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    pop.hidden = !on;
    if (!on) h.dataset.pinned = '';
    if (on) hilfePlace(h);
  }
  function hilfeCloseAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('.coni-em-hilfe.is-open'), function (h) { if (h !== except) hilfeSet(h, false); });
  }
  function hilfeBoot() {
    if (document.body.dataset.coniEmHilfe) return;
    document.body.dataset.coniEmHilfe = '1';
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var h = t.closest('.coni-em-hilfe');
      if (!h) { hilfeCloseAll(null); return; }
      ev.preventDefault();
      if (t.closest('.coni-em-hilfe__btn')) {
        if (h.dataset.pinned) { hilfeSet(h, false); }
        else { hilfeCloseAll(h); hilfeSet(h, true); h.dataset.pinned = '1'; }
      }
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' || ev.key === 'Esc') hilfeCloseAll(null); });
    if (HOVER) {
      document.addEventListener('mouseover', function (ev) {
        var h = ev.target && ev.target.closest ? ev.target.closest('.coni-em-hilfe') : null;
        if (h && !h.classList.contains('is-open')) { hilfeCloseAll(h); hilfeSet(h, true); }
      });
      document.addEventListener('mouseout', function (ev) {
        var h = ev.target && ev.target.closest ? ev.target.closest('.coni-em-hilfe') : null;
        if (!h || h.dataset.pinned) return;
        var to = ev.relatedTarget;
        if (to && h.contains(to)) return;
        hilfeSet(h, false);
      });
    }
    window.addEventListener('resize', function () { Array.prototype.forEach.call(document.querySelectorAll('.coni-em-hilfe.is-open'), hilfePlace); });
  }
  function boot() { hilfeBoot(); Array.prototype.forEach.call(document.querySelectorAll('.coni-em'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
